import React from 'react';
import Nav from "../../components/nav";
import AddBookForm from "../../components/book/addBookForm";

const AddBook = () => {
    return (
        <div>
            <Nav/>
            <AddBookForm/>
        </div>
    );
};

export default AddBook;